// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-label-link[data-v-e57284ea]{padding:4px 10px;background-color:#f6f361;border-radius:6px}.category-label-link[data-v-e57284ea]:hover{background-color:rgba(246,243,97,.4);color:#000}", ""]);
// Exports
module.exports = exports;
